import { Box, Typography } from '@mui/material'
import { StaticImageData } from 'next/image'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import List from '@ecm/ui/element/List'
import MainContainer from '@ecm/ui/element/MainContainer'

type VirtualMailboxProps = {
  illustration: StaticImageData
}

const VirtualMailbox = ({ illustration }: VirtualMailboxProps) => (
  <MainContainer>
    <Box
      p={{ md: '5em 0 2em', xs: '2em 0 0' }}
      display="grid"
      gap="2em"
      alignItems="center"
      gridTemplateColumns={{
        md: '1fr 1fr',
        xs: '1fr',
      }}
      gridTemplateRows={{
        md: '1fr',
        xs: 'auto 1fr',
      }}
    >
      <Box gridRow={{ md: 'auto', xs: '2' }}>
        <Typography variant="h3" component="h2">
          What is a Virtual Mailbox?
        </Typography>
        <Typography variant="p3">
          An Earth Class Mail virtual mailbox is a <b>digital mailbox service</b> that gives you the
          freedom to access your postal mail
        </Typography>
        <List
          items={['anywhere', 'anytime', 'from any device']}
          icon="/images/icon/checkmark.svg"
          variant="h5"
          pl="3em"
          my="2em"
          display={{ xl: 'flex', xs: 'block' }}
          justifyContent="space-between"
          sx={{
            '& li': {
              my: { xl: 0, xs: '1em' },
            },
            '& li:before': {
              left: '-45px',
              opacity: 0.7,
              width: '32px',
            },
          }}
        />
        <Typography variant="p3">
          With a virtual mailbox, use one of our 80+ real addresses to receive your mail digitally.
          Your postal mail arrives at one of our addresses and is carefully sorted, scanned for
          checks, and processed into high-quality PDFs — all viewable and actionable in your account
          dashboard.
        </Typography>
      </Box>
      <CloudflareImage src={illustration} />
    </Box>
  </MainContainer>
)

export default VirtualMailbox
